import React from 'react';

import { Box } from '@mui/material';
import type { Accept } from 'react-dropzone';
import Dropzone from 'react-dropzone';

import { SxProp } from 'src/types/mui';

export type FilePickerProps = {
  'data-test'?: string;
  'data-node-id'?: string;
  'data-node-render-path'?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  disableDrag?: boolean;
  maxFiles?: number;
  accept?: Accept;
  name?: string;
  containerSx?: SxProp;
  maxSize?: number;
  onChange: (files: File[]) => void;
};

export const FilePicker = React.forwardRef<HTMLDivElement, FilePickerProps>(
  (
    {
      'data-test': dataTest,
      'data-node-id': dataNodeID,
      'data-node-render-path': dataRenderPath,
      children,
      disabled = false,
      disableDrag = false,
      maxFiles = 0,
      maxSize,
      accept,
      name,
      containerSx,
      onChange,
    },
    ref,
  ) => {
    return (
      <Box
        ref={ref}
        data-test={dataTest}
        data-node-id={dataNodeID}
        data-node-render-path={dataRenderPath}
        sx={containerSx}
      >
        <Dropzone
          accept={accept}
          maxFiles={maxFiles}
          maxSize={maxSize}
          noDrag={disableDrag}
          onDrop={onChange}
          disabled={disabled}
          multiple
        >
          {({ getRootProps, getInputProps }) => {
            return (
              <div {...getRootProps()}>
                <input name={name} {...getInputProps()} />
                {children}
              </div>
            );
          }}
        </Dropzone>
      </Box>
    );
  },
);
